<template>
    <div class="home-container">
        <!-- banner -->
        <div class="home-banner" v-loading="!list.length">
            <swiper :options="headerSwiper" v-if="list.length" :style="{ height: swidth <= 768 ? '42vh' : '' }">
                <swiper-slide class="home-tiny" v-for="(item, index) in list" :key="index"><img :src="item.url"
                        :alt="$t('company_name')" srcset="" @click="bannerTo(item)">
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <!-- 数值卡片 -->
        <div class="home-card global-margin global-t-bt">
            <div class="home-card-item">
                <p class="card-item-1">AI Industry Pavilion Expert</p>
                <p class="card-item-2">{{ $t('home.p1') }}</p>
                <p class="card-item-3">{{ $t("home.p2") }}</p>
                <p class="card-item-4">{{ $t("home.p3") }}</p>
                <p class="card-item-4">{{ $t("home.p4") }}</p>
            </div>
            <ul v-if="!showords">
                <li v-for="(item, index) in words" :key="index" :class="[swidth > 768 ? 'w-25' : 'w-50']">
                    <div class="nums flex items-end flex-nowrap">
                        <AniNumber :num="item.number"></AniNumber>
                        <i v-if="item.nunit">{{ item.nunit }}</i>+<i v-if="item.unit" class="unit">{{ item.unit }}</i>
                        <i v-if="item.min" class="unit">min</i>
                    </div>
                    <p class="title">{{ item.title }}</p>
                    <p>{{ item.titleEn }}</p>
                </li>
            </ul>
        </div>
        <!-- 核心业务 -->
        <GlobalTitlte class="global-margin global-inner " En="Core Business" :Zh="$t('home.i1')">
            <template #right>
                <div class="gloabl-title-right">
                    {{ $t("home.i2") }}
                </div>
            </template>
        </GlobalTitlte>

        <div class="home-business global-margin global-inner global-t-bt">
            <img v-show="colsImg" :src="colsImg" alt="" srcset="" @click="jumpTo('business', colsImgId)">

            <el-empty class="m-auto" description="暂无数据" :image-size="swidth > 768 ? 200 : 100"
                v-show="!colsImg"></el-empty>
            <div class=" home-business-ul">
                <ul>
                    <li :class="[swidth > 768 ? '' : 'min-font-size ', colsIndex === index ? 'home-business-active' : '', lang !== 'zh_cn' ? '' : 'white-space-nowrap']"
                        v-for="(item, index) in cols" :key="index" @click="businessImg(item, index)">
                        <span>{{ item.category_name || '' }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 最新案例 -->
        <GlobalTitlte class="global-margin global-inner " En="New Cases" :Zh="$t('home.i3')" v-if="cases.length > 0">
        </GlobalTitlte>
        <div class="home-case global-margin global-inner global-t-bt" v-if="cases.length > 0">
            <NormalWithWords v-for="(item, index) in cases" :key="index" :photo="item.cover_img" shade="hover"
                :id="item.source_id" :alt="$t('company_name')"
                :class="[swidth > 768 ? 'new-case-pc-words' : 'new-case-m-words']" @click="jumpTo('case', item.id)">
                <template #words>
                    <div class="case-inner">
                        <div class="words">
                            <div class="title home-case-title">{{ item.title }}</div>
                            <div class="time">{{ item.service_content }}</div>
                        </div>
                    </div>
                </template>
            </NormalWithWords>
        </div>
        <!-- 公司实力 -->
        <GlobalTitlte class="global-margin global-inner " En="Company Strength" :Zh="$t('home.i4')">
            <template #right>
                <div class="gloabl-title-right">
                    {{ $t("home.i5") }}
                </div>
            </template>
        </GlobalTitlte>
        <div class="home-company global-margin global-inner global-t-bt" style="overflow: hidden;">
            <swiper :options="swidth > 768 ? swiperOptionThumbs : swiperOptionMThumbs" v-if="companyStrength.length">
                <swiper-slide v-for="(item, index) in companyStrength" :key="index">
                    <img :src="item.url" style="height: auto;" :alt="$t('company_name')" srcset="">
                </swiper-slide>
            </swiper>
        </div>

        <!-- 新闻中心 -->
        <div class="global-margin global-inner flex justify-between items-center flex-wrap">
            <GlobalTitlte En=" News Center" :Zh="$t('home.i7')" flex="flex">
                <template #right>
                </template>
            </GlobalTitlte>
            <div style="display: flex;">
                <el-button class="news-tab" :class="{ 'news-current-tab': index === newsTab, 'en-font': swidth <= 768 }"
                    v-for="(item, index) in newsTabs" :key="item.id" @click="changeTab(index, item.id)"
                    style="font-family: SourceHanSansCN-Normal">{{
                        item.category_name || ''
                    }}</el-button>
            </div>
        </div>
        <NewsCenter class="home-company global-margin global-inner global-t-bt" :items="items.slice(0, 3)"
            :swidth="swidth" v-loading="loading" />

        <!-- iframe传参弹窗 -->
        <innerFrame :dialogVisible="dialogVisible" src="https://www.333f.com/home" @close="dialogVisible = false">
        </innerFrame>
    </div>
</template>

<script>
import innerFrame from '../components/innerFrame.vue';
import AniNumber from '../components/AniNumber.vue';
import GlobalTitlte from '../components/GlobalTitlte.vue'
import NormalWithWords from '../components/NormalWithWords.vue'
import NewsCenter from '../components/NewsCenter.vue'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
    name: 'home',
    props: {
        swidth: {
            type: Number
        }
    },
    components: {
        swiper, swiperSlide,
        innerFrame,
        AniNumber,
        GlobalTitlte,
        NormalWithWords,
        NewsCenter
    },
    data() {
        return {
            list: [],
            cols: [],
            colsImg: '',
            colsImgId: '',
            colsIndex: 0,
            cases: [],
            companyStrength: [],
            newsTabs: [], // 新闻中心右侧的按钮
            newsTab: 0,
            items: [],
            dialogVisible: false,
            headerSwiper: {
                loop: true,
                pagination: {
                    el: '.swiper-pagination', // 分页器的DOM选择器，与slot="pagination"相对应
                    clickable: true, // 允许点击分页器上的小点来切换幻灯片
                },
                initialSlide: 0,
                autoplay: {
                    delay: 6000,
                },
            },
            swiperOptionThumbs: {
                loop: true,
                slidesPerView: 2,
                centeredSlides: true,
                slideToClickedSlide: true,
                effect: 'coverflow',
                coverflowEffect: {
                    rotate: 0,//slide做3d旋转时Y轴的旋转角度。默认50。
                    stretch: 70,//每个slide之间的拉伸值，越大slide靠得越紧。 
                    depth: 140,//slide的位置深度。值越大z轴距离越远，看起来越小。 
                    modifier: 1,//depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
                    slideShadows: true//开启slide阴影。默认 true。
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
            },
            swiperOptionMThumbs: {
                loop: true,
                slideToClickedSlide: true,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
            },
            words: [
                {
                    number: 0, // 补间动画的数字
                    unit: "㎡", // 单位
                    sqm: true, // 是否显示平方米
                    title: this.$t("home.o1"), // 中文标签
                    titleEn: "SPACE DESIGN AREA", // 英文标签
                },
                {
                    number: 0,
                    title: this.$t("home.o2"),
                    titleEn: "VISUAL DISPLAY CASE",
                },
                {
                    number: 90,
                    title: this.$t("home.o3"),
                    titleEn: "IND. QUALS & HONNORS",
                },
                {
                    number: 6000,
                    min: true, // 是否展示分钟
                    title: this.$t("home.o4"),
                    titleEn: "VIDEO PRODUCTION DURATION/MIN",
                },
                {
                    number: 29,
                    title: this.$t("home.o5"),
                    titleEn: "DIGITAL DISPLAY PATENT",
                },
                {
                    number: 5,
                    nunit: "W",
                    title: this.$t("home.o6"),
                    titleEn: "VISITS BY LEADERS",
                },
                {
                    number: 100,
                    title: this.$t("home.o7"),
                    titleEn: "INDUSTRY FIELD",
                },
                {
                    number: 1000,
                    title: this.$t("home.o8"),
                    titleEn: "NUM OF PARTNERS & CLIENTS",
                },
            ],
            showords: true,
            loading: true,
            lang: localStorage.getItem('333f-locale-lang') || 'zh_cn',
            defautlurl: 'https://external.333f.com/333f-2021-api/public/storage/'
        }
    },
    mounted() {
        this.getBanner()
        this.getCounter()
        this.getCategoryList()
        this.getLastestCase()
        this.getTypeList();
    },
    methods: {
        // banner
        getBanner() {
            this.$http.get('/api/index/getList').then(res => {
                if (res.code === 200) {
                    this.list = res.data.banner
                    this.companyStrength = res.data.honor
                }
            })
        },
        // banner底部数据
        getCounter() {
            this.$http.get('/api/index/countInfo').then(res => {
                if (res.code === 200) {
                    // this.words[0].number = Number(res.data.space_area)
                    // this.words[1].number = Number(res.data.visual_case)
                    // this.words[2].number = Number(res.data.industry_honors)
                    // this.words[3].number = Number(res.data.video_time)
                    // this.words[4].number = Number(res.data.digital_patent)
                    // this.words[5].number = Number(res.data.visit)
                    // this.words[6].number = Number(res.data.industry)
                    // this.words[7].number = Number(res.data.partners_cover)
                    let dataMap = {
                        space_area: 0,
                        visual_case: 1,
                        industry_honors: 2,
                        video_time: 3,
                        digital_patent: 4,
                        visit: 5,
                        industry: 6,
                        partners_cover: 7
                    }

                    // Update numbers in one loop
                    Object.entries(res.data).forEach(([key, value]) => {
                        let index = dataMap[key]
                        if (index !== undefined) {
                            this.words[index].number = Number(value)
                        }
                    })
                    this.showords = false
                }
            })
        },
        // 获取核心业务种类
        getCategoryList() {
            this.$http.get('/common/category/getList', {
                pid: 2,
                lang_code: this.lang,
                'to-tree': 0
            }).then((res) => {
                if (res.code == 200) {
                    this.cols = res.data;
                    this.colsIndex = 0
                    this.getCaseData(res.data[0].id)
                } else {
                    this.loading = false
                    // this.$message.error(res.msg);
                }
            });
        },
        // 核心业务
        getCaseData(category_id) {
            this.$http.get("/api/cases/pageList", {
                page: 1,
                per_page: 1,
                category_id: category_id
            }).then((res) => {
                if (res.code == 200) {
                    // this.colsImg = res.data.data.length ? res.data.data[0].img_list[0] : '';
                    // this.colsImgId = res.data.data.length ? res.data.data[0].id : ''
                    this.colsImg = res.data.data[0].cover_img;
                    this.colsImgId = res.data.data[0].id

                } else {
                    this.loading = false
                    // this.$message.error(res.msg);
                }
            });
        },
        // 核心业务转跳
        businessImg(item, index) {
            this.colsIndex = index
            this.getCaseData(item.id)
        },
        // 最新案例
        getLastestCase() {
            this.$http.get("/api/cases/latestList").then((res) => {
                if (res.code == 200) {
                    this.cases = res.data
                }
            });
        },
        //新闻分类
        getTypeList() {
            this.$http
                .get("/common/category/getList", { pid: 14, lang_code: this.lang, 'to-tree': 0 })
                .then((res) => {
                    if (res.code == 200) {
                        this.newsTabs = res.data;
                        this.getNewsList(res.data[0].id);
                    }
                })
                .catch((error) => {
                    this.newsTabs = error;
                });
        },
        //新闻列表
        getNewsList(id) {
            this.$http
                .get("/api/news/pageList", { page: 1, per_page: 3, category_id: id })
                .then((res) => {
                    if (res.code == 200) {
                        this.items = res.data.data;
                        this.loading = false
                    } else {

                        this.loading = false
                    }
                });
        },
        // 新闻中心切换按钮
        changeTab(index, id) {
            this.loading = true
            this.getNewsList(id);
            this.newsTab = index
        },

        bannerTo(item) {
            if (item.link) {
                window.open(item.link)
            }
        },
        jumpTo(type, id) {
            if (type == 'business' || type == 'case') {
                this.$router.push(`/industryPavilionCaseDetail?id=${id}`)
            }
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.home-container {
    width: 100%;

    .home-banner {
        position: relative;

        .home-tiny {
            // min-height: 40vh;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: 15% 50%;
            }
        }

    }

    .home-card {
        position: relative;
        // margin-bottom: 100px;
        // margin: 0 240px;

        ul {
            display: flex;
            // justify-content: space-between;
            margin-top: 100px;
            flex-wrap: wrap;

            li {
                // display: flex;
                padding: 0;
                // width: 250px;
                // flex: 1 1 250px;
                margin: 20px 0;

                .nums {
                    font-size: 48px;
                    color: @primaryColor;
                    font-weight: 700;
                    // display: flex;
                    // align-items: center;
                    // position: relative;

                    i {
                        font-style: normal;
                        // position: absolute;
                        // bottom: 10px;
                        // right: 0;
                    }

                    .unit {
                        font-size: 25px;
                    }
                }

                .title {
                    padding-bottom: 5px;
                }

                p {
                    font-size: 16px;
                }


            }
        }

        // ul:after {
        //     // 使用伪类元素占据单位，不影响页面
        //     content: "";
        //     height: 0;
        //     width: 32%;
        // }

        .home-card-item {
            position: absolute;
            top: -320px;
            right: 0;
            background-color: @primaryColor;
            padding: 32px 5%;
            color: #fff;
            letter-spacing: 1px;
            z-index: 1;

            .card-item-1 {
                font-size: 45px;
                font-weight: 700;
                padding-bottom: 6px;
            }

            .card-item-2 {
                font-size: 35px;
                padding-bottom: 16px;
            }

            .card-item-3 {
                font-size: 32px;
                font-weight: 600;
                padding-bottom: 16px;
            }

            .card-item-4 {
                font-size: 24px;
                font-weight: 100;
            }
        }
    }

    .home-business {
        margin-top: 20px;

        img {
            width: 100%;
        }

        .home-business-ul {
            ul {
                display: flex;
                flex-wrap: wrap;
                // margin-top: 10px;
                background: #eeeeee;
                padding: 10px;

                li {
                    width: 20%;
                    text-align: center;
                    padding: 8px 0;
                    margin: 6px 0;
                    font-size: 20px;
                    font-weight: 300;

                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .min-font-size {
                    font-size: 20px;
                    padding: 5px 0;
                    margin: 3px 0;
                }


                .home-business-active {
                    background: @primaryColor;
                    color: #fff !important;
                    border-radius: 5px;
                }

                li:hover {
                    color: @primaryColor;
                }
            }
        }
    }

    .home-case {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;

        .case-inner {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;

            .words {
                padding: 0 62px;
                font-size: 16px;
                font-weight: normal;
                color: #fff;

                .title {
                    text-align: center;
                    font-weight: 500;
                    // font-size: 36px;
                    color: @primaryColor;
                    font-family: Arial-BoldMT;
                }

                .time {
                    text-align: center;
                }
            }
        }
    }

    .home-company {
        // height: 500px;
        margin-top: 20px;

        img {
            // width: 86% !important;
            margin: auto;
            width: 100%;
        }
    }

    .news-tab {
        min-width: 124px;
        height: 42px;
        // color: $text-main-ZH-color;
        background: #ececec;
        border-radius: 4px;
        border: 0;
        font-size: 21px;
    }

    .news-current-tab {
        color: #fff;
        background: @primaryColor;
    }

    .tns-controls {
        display: none !important;
    }

    @media screen and (max-width: 900px) {
        .nums {
            font-size: 40px !important;
        }
    }

    @media screen and (min-width: 1025px) and (max-width: 1280px) {

        .home-card {
            // margin: 0 120px !important;

            // ul {
            //     margin: 0 20px !important;
            // }
        }

        // .home-card-item {
        //     position: relative !important;
        //     top: 0 !important;
        // }

    }

    @media screen and (min-width: 501px) and (max-width: 1024px) {

        .home-card {
            // margin: 0 60px !important;

            ul {
                margin: 0 !important;
            }
        }

        .home-card-item {
            position: relative !important;
            top: 0 !important;
        }

    }

    @media screen and (max-width: 500px) {
        .home-card {
            // margin: 0 0 !important;

            ul {
                margin: 0 40px !important;
            }
        }

        .home-card-item {
            position: relative !important;
            top: 0 !important;

        }
    }

    .new-case-pc-words {
        width: 33.3%;

        &:nth-child(3n) {
            margin-right: 0;
        }
    }

    .new-case-m-words {
        margin: 0 auto 20px;
        width: 96%;
    }

}


.tns-controls button {
    display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/home.vue